<script setup>
import { computed, onMounted, ref } from 'vue';
import { OVERVIEW_METRICS } from '../constants';
import { useToggle } from '@vueuse/core';

import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentStatus = useMapGetter('agents/getAgentStatus');
const accountConversationMetric = useMapGetter('getAccountConversationMetric');
const store = useStore();

const accounti18nKey = 'OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS';
const teams = useMapGetter('teams/getTeams');

const teamMenuList = computed(() => {
  return [
    { label: t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.ALL_TEAMS'), value: null },
    ...teams.value.map(team => ({ label: team.name, value: team.id })),
  ];
});

const agentStatusMetrics = computed(() => {
  let metric = {};
  Object.keys(agentStatus.value).forEach(key => {
    const metricName = t(
      `OVERVIEW_REPORTS.AGENT_STATUS.${OVERVIEW_METRICS[key]}`
    );
    metric[metricName] = agentStatus.value[key];
  });
  return metric;
});
const conversationMetrics = computed(() => {
  let metric = {};
  Object.keys(accountConversationMetric.value).forEach(key => {
    const metricName = t(`${accounti18nKey}.${OVERVIEW_METRICS[key]}`);
    metric[metricName] = accountConversationMetric.value[key];
  });
  return metric;
});

const selectedTeam = ref(null);
const selectedTeamLabel = computed(() => {
  const team =
    teamMenuList.value.find(
      menuItem => menuItem.value === selectedTeam.value
    ) || {};
  return team.label;
});
const fetchData = () => {
  const params = {};
  if (selectedTeam.value) {
    params.team_id = selectedTeam.value;
  }
  store.dispatch('fetchAccountConversationMetric', params);
};

const { startRefetching } = useLiveRefresh(fetchData);
const [showDropdown, toggleDropdown] = useToggle();

const handleAction = ({ value }) => {
  toggleDropdown(false);
  selectedTeam.value = value;
  fetchData();
};

onMounted(() => {
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="flex flex-col gap-3 sm:gap-4 md:grid md:grid-cols-2 md:gap-4 lg:gap-6 md:items-stretch">
    <div
      class="w-full conversation-metric h-full"
    >
            <MetricCard
        :header="t(`${accounti18nKey}.HEADER`)"
        :is-loading="uiFlags.isFetchingAccountConversationMetric"
        :loading-message="t(`${accounti18nKey}.LOADING_MESSAGE`)"
        class="h-full"
      >
        <!-- Botão removido por solicitação do usuário -->
        <!-- <template v-if="teams.length" #control>
          <div
            v-on-clickaway="() => toggleDropdown(false)"
            class="relative flex items-center group z-50"
          >
            <Button
              sm
              slate
              faded
              :label="selectedTeamLabel"
              class="capitalize rounded-md group-hover:bg-n-alpha-2 text-xs sm:text-sm"
              @click="toggleDropdown()"
            />
            <DropdownMenu
              v-if="showDropdown"
              :menu-items="teamMenuList"
              class="mt-1 ltr:right-0 rtl:left-0 xl:ltr:right-0 xl:rtl:left-0 top-full w-full sm:w-auto min-w-[200px]"
              label-class="capitalize text-xs sm:text-sm"
              @action="handleAction($event)"
            />
          </div>
        </template> -->
        <div
          v-for="(metric, name, index) in conversationMetrics"
          :key="index"
          class="flex flex-col items-center justify-center p-2 sm:p-1.5 md:p-2 text-center min-h-[60px] sm:min-h-[50px] md:min-h-[60px]"
        >
          <h3 class="text-sm sm:text-xs md:text-sm text-n-slate-11 leading-tight">
            {{ name }}
          </h3>
          <p class="text-n-slate-12 text-base sm:text-sm md:text-base lg:text-xl mb-0 mt-0.5 font-medium">
            {{ metric }}
          </p>
        </div>
      </MetricCard>
    </div>
        <div class="w-full h-full">
      <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_STATUS.HEADER')" class="h-full">
        <div
          v-for="(metric, name, index) in agentStatusMetrics"
          :key="index"
          class="flex flex-col items-center justify-center p-2 sm:p-1.5 md:p-2 text-center min-h-[60px] sm:min-h-[50px] md:min-h-[60px]"
        >
          <h3 class="text-sm sm:text-xs md:text-sm text-n-slate-11 leading-tight">
            {{ name }}
          </h3>
          <p class="text-n-slate-12 text-base sm:text-sm md:text-base lg:text-xl mb-0 mt-0.5 font-medium">
            {{ metric }}
          </p>
        </div>
      </MetricCard>
    </div>
  </div>
</template>
